import { Box } from "@mantine/core";

export interface PdfViewerProps {
    file: string | null;
}

export const PdfViewer = ({ file }: PdfViewerProps) => {
    if (!file) {
        return null;
    }

    let f = file;

    // internally, we store page numbers zero-based, but the PDF.js viewer
    // uses one-based page numbers
    const pageMatch = f.match(/(#page=)(\d+)/);
    if (pageMatch) {
        const currentPage = parseInt(pageMatch[2], 10);
        f = f.replace(/(#page=)\d+/, `$1${currentPage + 1}`);
    }
    return <iframe id="pdf-js-viewer" src={`static/pdfjs/web/viewer.html?file=${f}`} title="webviewer" height="100%" width="100%" />;
};
